/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useRef, useEffect } from "react";
import TreeCheckbox from "./treeCheckbox.jsx";
import { FaCaretDown } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { setStoreData } from "../../core/redux/filters/filter.action.jsx";
import "bootstrap/dist/css/bootstrap.min.css";

const GroupFilter = () => {
  const translation = useSelector((state) => state.root.translation);
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  //
  const { filter } = useSelector((state) => state.filter);
  const { selectedLocationStore } = filter;
  //
  const [mark, setMark] = useState([]);
  const [expend, setExpend] = useState(false);
  //
  const [drop, setDrop] = useState(false);
  const [search, setSearch] = useState("");
  //
  const { stores } = useSelector((state) => state.stores);
  const [nodeList, setNodeList] = useState([]);
  // stores
  useEffect(() => {
    function options() {
      if (stores) {
        let areaManagers = {};
        let perGroups = {};
        let regions = {};
        let districts = {};
        areaManagers.label = "Area Managers";
        areaManagers.value = "area_managers";
        areaManagers.children = stores.areaManagers.map((v) => {
          return {
            label: v.name,
            value: v.stores.map((val) => val.storeCode) || [""],
          };
        });
        // peer groups
        perGroups.label = "Peer Groups";
        perGroups.value = "peer_groups";
        perGroups.children = stores.peerGroups.map((v) => {
          return {
            label: v.name,
            value: v.stores.map((val) => val.storeCode) || [""],
          };
        });
        // region
        regions.label = "Regions";
        regions.value = "regions";
        regions.children = stores.regions
          .map(({ name, districts }) => {
            return {
              name,
              stores: districts.map(({ stores }) => stores).flat(),
            };
          })
          .map((v) => {
            return {
              label: v.name,
              value: v.stores.map((val) => val.storeCode) || [""],
            };
          });
        //   districts
        districts.label = "Districts";
        districts.value = "districts";
        districts.children = stores.regions
          .map((region) => region.districts)
          .flat()
          .map((v) => {
            return {
              label: v.name,
              value: v.stores.map((val) => val.storeCode) || [""],
            };
          });
        return [areaManagers, perGroups, regions, districts];
      }
    }
    setNodeList(options());
  }, [stores]);

  const handleClick = (selected) => {
    setMark(selected);
  };
  const expendClick = (selected) => {
    setExpend(selected);
  };
  const dropClick = () => {
    setDrop(!drop);
  };
  //
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDrop(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    setMark(selectedLocationStore);
  }, [selectedLocationStore]);
  //
  const dataFiltered = () => {
    if (search) {
      return nodeList
        .map((category) => {
          const matchingChildren = category.children.filter((child) =>
            child.label.toLowerCase().includes(search.toLowerCase())
          );
          return { ...category, children: matchingChildren };
        })
        .filter((category) => category.children.length > 0);
    } else {
      return nodeList;
    }
  };
  const cancel = () => {
    setMark(selectedLocationStore);
    setDrop(false)
  };

  const submit = () => {
    dispatch(setStoreData({ selectedLocationStore: mark }));
    setDrop(false)
  };

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button
        className="btn dropdown-toggle nav-link select-group"
        type="button"
        onClick={dropClick}
        style={{
          border: "1px solid #ced4da",
          backgroundColor: "transparent",
        }}
      >
        <i className="fas fa-sitemap"></i> {translation?.groups || "Groups"} <FaCaretDown />
      </button>
      <div className={`group-select dropdown-menu${drop ? " show" : ""}`} style={{ minWidth: "250px" }}>
        <div className="p-3">
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Search"
            onChange={(event) => setSearch(event.target.value)}
          />
          <div className="scroll-wrapper">
          {dataFiltered().map((item, key) => {
            return (
              <div key={key} className="mb-2">
                <TreeCheckbox
                  data={item}
                  mark={mark}
                  onClick={handleClick}
                  dropClick={expendClick}
                  expend={expend}
                />
              </div>
            );
          })}
          </div>
          <div className="d-flex justify-content-center">
            <button
              className="btn btn-primary-light m-2"
              onClick={cancel}
            >
              {translation?.cancel || "Cancel"}
              
            </button>
            <button
              className="btn btn-primary m-2"
              disabled={!mark || !mark.length}
              onClick={submit}
            >
              {translation?.apply || "Apply"}
              
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupFilter;
